import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ConfirmationModal from "views/components/ConfirmationModal";
import ToastModal from "views/components/ToastModal";
const StandardDeductionCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const [StandardDeductionName, setStandardDeductionName] = useState("");
  const [StandardDeductionNameState, setStandardDeductionNameState] =
    useState(false);
  const [stoneWeightMaxPercentage, setStoneWeightMaxPercentage] = useState("");
  const [stoneWeightMaxPercentageState, setStoneWeightMaxPercentageState] =
    useState(false);
  const [stoneWeightMinPercentage, setStoneWeightMinPercentage] = useState("");
  const [stoneWeightMinPercentageState, setStoneWeightMinPercentageState] =
    useState(false);
  // const [isActive, setIsActive] = useState(true);
  const [groupDetails, setGroupDetails] = useState([
    {
      minStoneWeightPercentage: "",
      maxStoneWeightPercentage: "",
      standardDeduction: "",
      criteria: "deduction",
      acceptable: true,
    },
  ]);
  const [lastIndex, setLastIndex] = useState(0);
  const [standardDeductionLength, setSchemeChargeLength] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [masterTypeList, setMasterTypeList] = useState([]);
  const dispatch = useDispatch();
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [disableButton, setDisableButton] = useState(false)
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    let isValid = true;
  
    for (const item of groupDetails) {
      if (
        item.minStoneWeightPercentage === "" ||
        item.maxStoneWeightPercentage === "" ||
        item.standardDeduction === ""
      ) {
        isValid = false;
        break;
      }
    }
  
    return isValid;
  };

  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.DEDUCTION_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);

    if (result?.data) {
      setLastIndex(result?.data?.length - 1);
      setGroupDetails(result?.data);
    }
  };
  const deleteRow = (i) => {
    setConfirmationModalHeader("Delete Deduction");
    setConfirmationModalMsg("Are you sure you want to delete this deduction");
    setConfirmationModal(true);
    setDeleteId(i);
    setDisableButton(false)
  };

  const handlePositiveResponse = async () => {
    handleNegativeResponse();
    // Call API to delete Charges
    setLastIndex(lastIndex - 1);
    setGroupDetails((prev) => prev.filter((p, j) => deleteId !== j));
  };
  const saveStandardDeduction = async () => {
    const bulkData = {
      standardDeductions: groupDetails,
    };
    if (isValidated()) {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.DEDUCTION_CREATE,
        method: "POST",
        authToken: authToken,
        data: bulkData,
      });
      setCallInProgress(false);
      if (res?.data?.error_code) {
        toastUpdate("Error", res?.data?.user_description, true);
      } else {
        toastUpdate("Success", "Standard Deduction Master updated Successfully!", true);
        setRedirectURL(`/coreservice/StandardDeduction`);
      }
    } else {
      toastUpdate("Error", "Please provide valid fields in all rows" , true);
    }
  };

  const addData = () => {
    addNextRow();
  };
  const addNextRow = () => {
    let newIndex = lastIndex + 1;
    setLastIndex(newIndex);
    let newArr = [...groupDetails]; // copying the old datas array
    newArr[newIndex] = {
      minStoneWeightPercentage: "",
      maxStoneWeightPercentage: "",
      standardDeduction: "",
      criteria: "deduction",
      acceptable: true,
    };
    setGroupDetails(newArr);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
  };

  const handleChange = (e, i, label) => {
    let newArr = [...groupDetails];
    let item = newArr[i];
    const regex  = /^\d*\.?\d*$/;
    if (label === "minStoneWeightPercentage" && regex.test(e)) {
      item = { ...item, minStoneWeightPercentage: e };
    } else if (label === "maxStoneWeightPercentage" && regex.test(e)) {
      item = { ...item, maxStoneWeightPercentage: e };
    } else if (label === "standardDeduction" && regex.test(e)) {
      item = { ...item, standardDeduction: e };
    } else if (label === "isActive") {
      item = { ...item, acceptable: e };
    } else {
      item = { ...item, criteria: "deduction" };
    }
    newArr[i] = item;
    setGroupDetails(newArr);
  };
  const handlecancelDeduction = () => {
    navigate("/coreservice/StandardDeduction");
  };
  const handleOverlapping = (e,index, label) =>{
    if(label === "minStoneWeightPercentage" && e !== "" && (e < Number(groupDetails?.[index -1]?.maxStoneWeightPercentage) || e > Number(groupDetails?.[index + 1]?.minStoneWeightPercentage))){
      toastUpdate("Error", "Value should not overlap in existing values", true);
        setDisableButton(true)
    }else if(label === "maxStoneWeighPercentage" && (e < Number(groupDetails?.[index]?.minStoneWeightPercentage) || (groupDetails?.[index + 1]?.minStoneWeightPercentage !== undefined && e > Number(groupDetails?.[index + 1]?.minStoneWeightPercentage)) || e < Number(groupDetails?.[index - 1]?.maxStoneWeightPercentage))){
      toastUpdate("Error", "Value should not overlap in existing values", true);
       setDisableButton(true)
   }else{
       setDisableButton(false)
   }
  }

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={
            params.deductionId
              ? "Edit Standard Deduction"
              : "Create Standard Deduction"
          }
          button1=" Save"T
          button2=" Cancel"
          disabled1={disableButton}
          button1click={saveStandardDeduction}
          button2click={handlecancelDeduction}
        />
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        className={`${classes.inputFieldContainer} ${classes.deductionContainer}`}
      >
        <div>
          <Button
            className={classes.button}
            onClick={() => {
              addData();
              // setLastIndex(lastIndex + 1);
            }}
            id="button"
          >
            Add
          </Button>
        </div>
        <div className={classes.buttonContainer}>
        <Button
            className={classes.button2}
            onClick={() => deleteRow(0)}
            id="button"
          >
            Delete
          </Button>
        </div>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        {Array.apply(null, { length: lastIndex + 1 }).map((e, i) => (
          <Grid container className={classes.inputFieldContainer} key={i}>
            {i !== 0 && (
              <Grid
              item
                xs={12}
                sm={12}
                md={12}
                className={classes.buttonDelContainer}
              >
                {standardDeductionLength !== i && (
                  <Button
                    className={classes.button2}
                    onClick={() => deleteRow(i)}
                    id="button"
                  >
                    Delete
                  </Button>
                )}
              </Grid>
            )}
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Minimum Stone Weight Percentage"
                required
                id="lp_min_stone"
                error={stoneWeightMinPercentageState}
                value={groupDetails?.[i]?.minStoneWeightPercentage}
                setState={handleChange}
                setError={setStoneWeightMinPercentageState}
                setBlur={handleOverlapping}
                index={i}
                name="minStoneWeightPercentage"
                blurLabel= "minStoneWeightPercentage"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Maximum Stone Weight Percentage"
                required
                id="lp_max_stone"
                error={stoneWeightMaxPercentageState}
                value={groupDetails?.[i]?.maxStoneWeightPercentage}
                setState={handleChange}
                setError={setStoneWeightMaxPercentageState}
                index={i}
                name="maxStoneWeightPercentage"
                blurLabel= "maxStoneWeighPercentage"
                setBlur={handleOverlapping}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <CustomeTextField
                label="Standard Deduction"
                required
                id="standard_deduction"
                error={StandardDeductionNameState}
                value={groupDetails?.[i]?.standardDeduction}
                setState={handleChange}
                setError={setStandardDeductionNameState}
                index={i}
                name="standardDeduction"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
              <p style={{ fontWeight: "bold" }}>
                {" "}
                <input
                  id="selectAll"
                  type="checkbox"
                  checked={groupDetails?.[i].acceptable}
                  className={classes.checkboxInput}
                  onChange={(e) => {
                    handleChange(e.target.checked, i, "isActive");
                  }}
                />{" "}
                Acceptable
              </p>
            </Grid>
          </Grid>
        ))}
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default StandardDeductionCreate;
